import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import OmitType from "customTypes/OmitType";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import CheckboxTickIcon from "assets/svgs/icons/CheckboxTickIcon";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            color: "#0d6b6b",
        },
        iconBackground: {
            display: "flex",
            width: 18,
            height: 18,
            backgroundColor: theme.palette.common.white,
            border: `1px solid ${theme.palette.common.black}`,
        },
        icon: {
            padding: 2,
            flex: "1 1 auto",
        },
        "&$checked": {
            color: "#0d6b6b",
        },
    })
);

interface IProps extends OmitType<CheckboxProps, "color"> {}

export default function StyledCheckBox(props: IProps) {
    const { className = "", ...rest } = props;
    const classes = useStyles();

    return (
        <Checkbox
            color="default"
            className={clsx(className, classes.root)}
            checkedIcon={
                <span className={classes.iconBackground}>
                    <CheckboxTickIcon className={classes.icon} />
                </span>
            }
            icon={<span className={classes.iconBackground} />}
            {...rest}
        />
    );
}
